import React, { useState, useEffect } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { useMutation } from '@apollo/client'
import { usePlan } from '../../../context/PlanContext'
import {
  CREATE_PLAN_FOR_BG_ACCOUNT,
  PAYMENT_GATEWAY_TO_CREATE_PLAN
} from '../../../graphql/mutation'
import { GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT } from '../../../graphql/query'
import { useNavigate } from 'react-router-dom'
interface IProps {
  closePaymentProcessingModal: any
  closeConfirmPaymentModal: any
  closePaymentModal: any
  plan: any
  //   data: any
}

const ProcessingPayment: React.FC<IProps> = ({
  closePaymentProcessingModal,
  closeConfirmPaymentModal,
  closePaymentModal,
  plan
  //   data
}) => {
  const [progress, setProgress] = useState(0)
  const [paymentCompleted, setPaymentCompleted] = useState(false)
  const { data1 } = usePlan()
  const [selectedPlan, setSelectedPlan] = useState<any>('')
  const [stopProgressBar, setStopProgressBar] = useState<any>(false)
  const navigate = useNavigate()
  const [paymentGateWayToCreatePlan] = useMutation(PAYMENT_GATEWAY_TO_CREATE_PLAN, {
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  const [createPlanForBgAccount] = useMutation(CREATE_PLAN_FOR_BG_ACCOUNT, {
    refetchQueries: [
      {
        query: GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT,
        variables: {
          input: {
            bgAccountId: parseInt(data1?.getBgAccountById?.id)
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'AdminPermission'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 10 : 100))
    }, 500)

    if (progress === 100) {
      clearInterval(interval)

      setStopProgressBar(true)
      // Call closePaymentProcessingModal if you want to close modal after completion
      // closePaymentProcessingModal()
    }

    return () => clearInterval(interval)
  }, [progress, closePaymentProcessingModal])

  useEffect(() => {
    if (stopProgressBar) {
      paymentGateWayToCreatePlan({
        variables: {
          input: {
            bgAccountId: parseInt(data1?.getBgAccountById?.id),
            packageFeatureId: plan?.packageFeatureId,
            payingAmount: plan?.price
          }
        }
      })
        .then((res: any) => {
          if (res.data) {
            setSelectedPlan(plan?.package?.packageName)
            createPlanForBgAccount({
              variables: {
                input: {
                  bgAccountId: parseInt(data1?.getBgAccountById?.id),
                  packageFeatureId: plan?.packageFeatureId,
                  payingAmount: plan?.price,
                  startDate: new Date().toISOString().split('T')[0]
                }
              }
            })
              .then((res: any) => {
                if (res.data) {
                  setPaymentCompleted(true)
                } else {
                  closePaymentProcessingModal()
                }
              })
              .catch((err: any) => {
                closePaymentProcessingModal()
              })
          }
        })
        .catch((err: any) => {
          closePaymentProcessingModal()
        })
    }
  }, [stopProgressBar])

  const closeAllModal = () => {
    closePaymentProcessingModal()
    closeConfirmPaymentModal()
    closePaymentModal()
    navigate('/onboarding/personal-details')
  }

  return (
    <div className='card h-xl-100'>
      <div className='card-body d-flex flex-column pt-13 pb-14'>
        <div className='m-0'>
          {!paymentCompleted ? (
            <>
              <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Processing Payment</h1>
              <div className='flex-grow-1 card-rounded-bottom h-200px mh-200px my-5 mb-lg-12'>
                <div style={{ width: '200px', height: '300px', margin: '0 auto' }}>
                  <CircularProgressbar
                    value={progress}
                    text={`${progress}%`}
                    styles={buildStyles({
                      pathColor: `rgba(60, 179, 113, ${progress / 100})`,
                      textColor: '#000000',
                      trailColor: '#d6d6d6',
                      backgroundColor: '#3e98c7'
                    })}
                  />
                </div>
              </div>
              <h6 className='text-black text-center lh-lg mb-9'>Please Do Not Close This Page</h6>
            </>
          ) : (
            <>
              <div className='text-center'>
                <i className='bi bi-check-circle-fill display-1 text-success'></i>
              </div>
              <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Payment Completed</h1>
              <h3 className='text-muted text-center lh-lg mb-9'>
                Your plan has been successfully created
                <h3 className='text-black'>{selectedPlan}</h3>
              </h3>
              {/* <h5 className='text-black text-center lh-lg mb-9'>Invoice Number: {invoiceNumber}</h5> */}
              <div className='text-center'>
                <button className='btn btn-primary' onClick={closeAllModal}>
                  Continue
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProcessingPayment
